// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/adozione/mie-attivita',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"titolo":"Inserire i primi 10 ordini","descrizione":null,"scadenza":"2026-10-15","stato":"DA_FARE","notaAssegnatario":null,"completatoAt":null,"inRitardo":false,"obiettivo":{"id":1,"titolo":"Ciclo attivo operativo"},"piano":{"id":1,"titolo":"Adozione BOP 2026","societaId":1,"dataFine":"2026-12-10","societa":{"id":1,"nome":"Pianinvest"}}}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/adozione/attivita/1/stato',
    requestBody: '{"stato":"IN_CORSO","notaAssegnatario":"iniziato oggi"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/adozione/feedback',
    requestBody: '{"attivitaId":1,"tipo":"DIFFICOLTA","testo":"..."}',
    response: '{"success":true,"data":{"id":1}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
